import { render, staticRenderFns } from "./veStuHealthAskEdit.vue?vue&type=template&id=49d09f62&scoped=true"
import script from "./veStuHealthAskEdit.vue?vue&type=script&lang=js"
export * from "./veStuHealthAskEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d09f62",
  null
  
)

export default component.exports